import styled from '../../styles/styled';
import AppText from '../typography/app_text';
export const BlackBar = styled.div({
    height: 2,
    transition: 'all 0.2s',
    marginTop: 5,
}, ({ active, theme }) => ({
    background: theme.gradients.lightGradient,
    width: active ? '100%' : 0,
}));
export const TabTitle = styled(AppText.withComponent('h2'))({
    transition: 'color 0.2s',
}, ({ active, theme }) => ({
    ':hover': {
        color: theme.colors.grey90,
    },
    color: active ? theme.colors.grey90 : theme.colors.grey60,
    fontFamily: theme.text.headingFontFamily,
}));
export const PageLinkButton = styled.button({
    cursor: 'pointer',
    padding: 0,
    margin: 0,
    background: 'none',
    border: 'none',
});
//# sourceMappingURL=page_link.styles.js.map